import { defineAsyncComponent as defineAsyncComponentDefault } from "vue";
import componentLoading from "@common/loading/componentLoading";

let defineAsyncComponent = function (source) {
    return defineAsyncComponentDefault({
        // the loader function
        loader: source,
        // A component to use while the async component is loading
        loadingComponent: componentLoading,
        // Delay before showing the loading component. Default: 200ms.
        delay: 0,
        // A component to use if the load fails
        // errorComponent: ErrorComponent
    });
};

export default defineAsyncComponent;
export { defineAsyncComponent };
